import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Checkbox,
  Stack,
  FormGroup,
} from '@mui/material'
import React, { ReactElement } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from 'redux/Hook'
import type { Dispatch } from 'redux'

interface CheckboxGroupProps {
  label: string
  options: any[]
  values?: string[]
  onChange: (name: string, value: boolean, dispatch: Dispatch) => void
  renderConditionalComponents?: (option: string, props: any) => ReactElement[]
}

const CheckboxGroup = (props: CheckboxGroupProps) => {
  const { label, renderConditionalComponents, options, onChange } = props
  const toolState = useAppSelector(
    (state) => state.toolBuilder.toolBuilder,
  ) as Record<string, string>
  const { fetching, saving } = useAppSelector((state) => state.toolBuilder)

  const dispatch = useDispatch()

  const conditionalComponents = options.map((option) => {
    const isChecked = toolState[option.id as string]

    if (isChecked && renderConditionalComponents) {
      return renderConditionalComponents(option.id, { required: true })
    }
    return null
  })

  return (
    <Stack>
      <FormControl>
        <FormLabel>{label}</FormLabel>
        <FormGroup>
          {options.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  disabled={fetching || saving}
                  checked={!!toolState[option.id as string]}
                />
              }
              label={option.label}
              key={index}
              onChange={(_, checked: boolean) => {
                return onChange(option?.id, checked, dispatch)
              }}
            />
          ))}
        </FormGroup>
      </FormControl>

      {conditionalComponents}
    </Stack>
  )
}

export default CheckboxGroup
